import { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { linkChild } from '../services/parentApi';

export default function LinkChild() {
  const [searchParams] = useSearchParams();
  const initialCode = searchParams.get('code') || '';
  const [code, setCode] = useState(initialCode);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await linkChild(code);
      navigate('/');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm mb-4 inline-block">
        ← Retour au tableau de bord
      </Link>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
        <div className="text-center mb-8">
          <span className="text-5xl">🔗</span>
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Ajouter un enfant</h1>
          <p className="mt-2 text-slate-600">
            Entrez le code parent fourni par votre enfant
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h3 className="font-medium text-blue-900 mb-2">Comment obtenir le code ?</h3>
          <ol className="text-sm text-blue-800 space-y-1">
            <li>1. Votre enfant ouvre l'app Methodix</li>
            <li>2. Il va dans Paramètres → Code Parent</li>
            <li>3. Il vous partage son code (ex: 2025-A2952444)</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="code" className="block text-sm font-medium text-slate-700">
              Code parent
            </label>
            <input
              id="code"
              type="text"
              required
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              className="mt-1 block w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-center text-lg tracking-wider font-mono"
              placeholder="2025-XXXXXXXX"
            />
          </div>

          <button
            type="submit"
            disabled={loading || code.length < 10}
            className="w-full py-3 px-4 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Liaison en cours...' : 'Lier cet enfant'}
          </button>
        </form>
      </div>
    </div>
  );
}

